import constate from "constate";
import { useColumnSelectionContext } from "./useColumnSelectionContext.js";
import { useColumns } from "./useColumnsContext.js";
import { useCallback, useMemo } from "react";
const createNewOverlayIndex = (overlays, activeGroupKey, columnWidth) => {
  if (!overlays[activeGroupKey]) {
    overlays[activeGroupKey] = {
      columnConfigKeys: [activeGroupKey],
      width: columnWidth
    };
  }
};
const addToOverlayIndex = (overlays, activeGroupKey, newColumnConfigKey, columnWidth) => {
  overlays[activeGroupKey].columnConfigKeys.push(newColumnConfigKey);
  overlays[activeGroupKey].width += columnWidth;
};
const useColumnSelectionGroup = () => {
  const { columnSelections, queuedColumnSelections } = useColumnSelectionContext();
  const { columnValueToIndex, columnStyles } = useColumns();
  const keysWithPinsFirst = useCallback(
    (values) => {
      return values.sort((a, b) => {
        const aVisualPosition = columnValueToIndex[a];
        const bVisualPosition = columnValueToIndex[b];
        return aVisualPosition - bVisualPosition;
      });
    },
    [columnValueToIndex]
  );
  const buildOverlays = (columnConfigKeys) => {
    var _a;
    const overlays = {};
    const keys = keysWithPinsFirst(columnConfigKeys);
    let previousVisualPositionIndex = null;
    let activeGroupKey = null;
    for (const columnConfigKey of keys) {
      const visualPositionIndex = columnValueToIndex[columnConfigKey];
      const columnWidth = (_a = columnStyles[visualPositionIndex]) == null ? void 0 : _a.width;
      if (activeGroupKey && previousVisualPositionIndex === visualPositionIndex - 1) {
        addToOverlayIndex(
          overlays,
          activeGroupKey,
          columnConfigKey,
          columnWidth
        );
      } else {
        activeGroupKey = columnConfigKey;
        createNewOverlayIndex(overlays, activeGroupKey, columnWidth);
      }
      previousVisualPositionIndex = visualPositionIndex;
    }
    return overlays;
  };
  const [indexedOverlays, queuedOverlays] = useMemo(() => {
    const overlays = buildOverlays(columnSelections);
    const queuedOverlays2 = buildOverlays(queuedColumnSelections);
    return [overlays, queuedOverlays2];
  }, [
    columnSelections,
    queuedColumnSelections,
    columnValueToIndex,
    columnStyles
  ]);
  return { indexedOverlays, queuedOverlays };
};
const [ColumnSelectionGroupProvider, useColumnSelectionGroupContext] = constate(
  useColumnSelectionGroup
);
export {
  ColumnSelectionGroupProvider,
  useColumnSelectionGroup,
  useColumnSelectionGroupContext
};
